import { unstable_usePrompt as usePrompt } from 'react-router-dom';
import usePreventLeaving from './usePreventLeaving';

const promptMessage =
  'You have not yet saved your changes. Are you sure you want to discard them?';

const useBeforeLeaveConfirm = ({ skip = false } = {}) => {
  usePreventLeaving({ skip });
  usePrompt({
    when: !skip,
    message: promptMessage,
  });
};

export default useBeforeLeaveConfirm;
